import { createContext, useContext, useEffect, useState } from 'react';

function getDefaultEnvironment(){
  return {
    COOKIE_NAME: process.env.REACT_APP_COOKIE_NAME,
    SERVER_API: process.env.REACT_APP_SERVER
  };
}

const EnvContext = createContext(null);

export function useEnvContext() { 
    return useContext(EnvContext); 
}

export function EnvContextProvider ({children}) {
  const [env, setEnv] = useState(getDefaultEnvironment());
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/env`)
    .then(async (response) => { 
      var env = await response.json();
      if(response.ok) {
        setEnv(env);
      } else {
        setEnv(getDefaultEnvironment());
      }
    })
    .catch(error => {
      setEnv(getDefaultEnvironment());
    })
  }, []);

  return (
    <EnvContext.Provider value={env}>
        {children}
    </EnvContext.Provider>
  );
}